// Injects the Tauri permission IPC calls (mic pair via `recorderFmc`,
// accessibility trio via `@/tauri/dictation/permissions`) into
// @heidi/dictate's permissions-ports seam (SCR-7069). Imported for effect
// in `_app.tsx`. The package short-circuits to "granted" off-Tauri, so the
// ports are only reached after this wiring has run.
import { recorderFmc } from '@/tauri/controller/recording';
import {
  checkAccessibilityPermission,
  openAccessibilityPrivacySettings,
  requestAccessibilityPermission,
} from '@/tauri/dictation/permissions';
import { configureDictationPermissionsPorts } from '@heidi/dictate';

configureDictationPermissionsPorts({
  checkMicrophonePermission: () => recorderFmc.check_microphone_permission(),
  openMicrophoneSettings: () => recorderFmc.open_mic_privacy_settings(),
  checkAccessibilityPermission,
  requestAccessibilityPermission,
  openAccessibilityPrivacySettings,
});
